import type { SeedStatsDto } from '@/core/data/seed/seed.interface';
import { gambits } from '@/core/gambits';
import { createLogger } from '@/core/helpers/logger.helper';
import { defineStore } from 'pinia';
import { ref } from 'vue';

const logger = createLogger('SeedStore');

export const useSeedStore = defineStore('seed', () => {
  const stats = ref<SeedStatsDto | null>(null);
  const isLoading = ref(false);
  const isError = ref(false);

  async function fetchStats() {
    isLoading.value = true;
    isError.value = false;
    try {
      const result = await gambits.seedService.getStats();
      if (result.data) {
        stats.value = result.data;
      } else {
        isError.value = true;
        logger.error('Failed to fetch seed stats', result.error);
      }
    } catch (e) {
      isError.value = true;
      logger.error('Unexpected error fetching seed stats', e);
    } finally {
      isLoading.value = false;
    }
  }

  function $reset() {
    stats.value = null;
    isLoading.value = false;
    isError.value = false;
  }

  return {
    stats,
    isLoading,
    isError,
    fetchStats,
    $reset,
  };
});
